import React from 'react';
import Proptypes from 'prop-types';
import { getSaxsHPLCFrame } from './IORequests';
import DataSerie from '../../../helpers/Saxs/DataSerie';
import _ from 'lodash';

/** React container which is used to retrieved data associated to a single frame number. The data response contains several curves*/
class SaxsHPLCFrameContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dataSeries: null, // CSV data
            experimentId: null,
            fetched: false,
            fetching: false,
            frameId: null,
        }

        this.getFrames = this.getFrames.bind(this);
        this.parse = this.parse.bind(this);
    }

    render() {
        if (this.props.experimentId && this.props.frameId) {
            if (this.props.frameId !== this.state.frameId) {
                this.getFrames();
            }
            return this.props.children(this.state.dataSeries);
        } else {
            return this.props.children(null);
        }
    }

    getFrames() {
        const onSuccess = (response) => {
            this.setState({
                dataSeries: this.parse(response.data),
                experimentId: this.props.experimentId,
                fetched: true,
                fetching: false,
                frameId: this.props.frameId,
            });
        }

        const onError = (error) => {
            debugger;
            this.setState({
                error: error,
                fetching: false,
                fetched: false
            });
        }

        getSaxsHPLCFrame(this.props.token, this.props.proposal, this.props.experimentId, this.props.frameId, onSuccess, onError);
    }



    /**
 * Parser from csv to dataSerie array
 * @param {*} csvData 
 */
    parse(csvData) {
        let splitData = csvData.toString().split("\n");

        let dataSerie1 = new DataSerie('#' + this.props.frameId + '_RawIntensity', [], [], '', '#' + this.props.frameId, false);
        let dataSerie2 = new DataSerie('#' + this.props.frameId + '_BufferAverage', [], [], '', '#' + this.props.frameId + '_buffer_ave', false);
        let dataSerie3 = new DataSerie('#' + this.props.frameId + '_SubtractionIntensity', [], [], '', '#' + this.props.frameId + '_sub', false);
        let dataSerieError1 = new DataSerie('#' + this.props.frameId + '_RawIntensityStdDev', [], [], '', '', true);
        let dataSerieError2 = new DataSerie('#' + this.props.frameId + '_BufferAverageStdDev', [], [], '', '', true);
        let dataSerieError3 = new DataSerie('#' + this.props.frameId + '_SubtractionIntensityStdDev', [], [], '', '', true);

        let dataSerieError1Index = 0;
        let dataSerieError2Index = 0;
        let dataSerieError3Index = 0;

        for (let i = 0; i < splitData.length; i++) {
            let line = splitData[i].trim();
            let splitLine = line.split(/\s*[\s,]\s*/);

            if (splitLine.length === 7) {
                dataSerie1.pushPoint(Number(splitLine[0]), Number(splitLine[1]));
                dataSerie2.pushPoint(Number(splitLine[0]), Number(splitLine[5]));
                dataSerie3.pushPoint(Number(splitLine[0]), Number(splitLine[3]));

                if (dataSerieError1Index === 0) {
                    dataSerieError1.pushPoint(Number(splitLine[0]), Number(splitLine[1]) + Number(splitLine[2]));
                    dataSerieError1.pushPoint(Number(splitLine[0]), Number(splitLine[1]) - Number(splitLine[2]));
                } else {
                    dataSerieError1.addPointByIndex(Number(splitLine[0]), Number(splitLine[1]) + Number(splitLine[2]), dataSerieError1Index)
                    dataSerieError1.addPointByIndex(Number(splitLine[0]), Number(splitLine[1]) - Number(splitLine[2]), dataSerieError1.values.x.length - dataSerieError1Index);
                }
                dataSerieError1Index++;

                if (dataSerieError2Index === 0) {
                    dataSerieError2.pushPoint(Number(splitLine[0]), Number(splitLine[5]) + Number(splitLine[6]));
                    dataSerieError2.pushPoint(Number(splitLine[0]), Number(splitLine[5]) - Number(splitLine[6]));
                } else {
                    dataSerieError2.addPointByIndex(Number(splitLine[0]), Number(splitLine[5]) + Number(splitLine[6]), dataSerieError2Index)
                    dataSerieError2.addPointByIndex(Number(splitLine[0]), Number(splitLine[5]) - Number(splitLine[6]), dataSerieError2.values.x.length - dataSerieError2Index);
                }
                dataSerieError2Index++;

                if (dataSerieError3Index === 0) {
                    dataSerieError3.pushPoint(Number(splitLine[0]), Number(splitLine[3]) + Number(splitLine[4]));
                    dataSerieError3.pushPoint(Number(splitLine[0]), Number(splitLine[3]) - Number(splitLine[4]));
                } else {
                    dataSerieError3.addPointByIndex(Number(splitLine[0]), Number(splitLine[3]) + Number(splitLine[4]), dataSerieError3Index)
                    dataSerieError3.addPointByIndex(Number(splitLine[0]), Number(splitLine[3]) - Number(splitLine[4]), dataSerieError3.values.x.length - dataSerieError3Index);
                }
                dataSerieError3Index++;
            }
        }

        return [dataSerie1, dataSerie2, dataSerie3, dataSerieError1, dataSerieError2, dataSerieError3.plotLiWorkAround()];
    }
}


export default SaxsHPLCFrameContainer;

SaxsHPLCFrameContainer.proptypes = {
    /* Experiment identifier */
    experimentId: Proptypes.number,
    /* Frame number as provided by the X value of the HPLC graph */
    frameId: Proptypes.number,
    /* Proposal name */
    proposal: Proptypes.string,
    /* Authentication token */
    token: Proptypes.string
}


// WEBPACK FOOTER //
// ./src/containers/saxs/helpers/SaxsHPLCFrameContainer.js